// 小于10的数字，十位补零
function formatDigit(num: number): string {
  if (num >= 10) {
    return num + "";
  } else {
    return "0" + num;
  }
}

// 格式化数字
export function formatNum(num: string | number): string | number {
  // @ts-ignore
  const intNum = parseInt(num, 10);
  if (Number.isNaN(intNum) || intNum < 0) {
    return "-";
  }
  if (intNum >= 10000 && intNum < 100000000) {
    return (intNum / 10000).toFixed(1) + "万";
  }
  if (intNum >= 100000000) {
    return (intNum / 100000000).toFixed(1) + "亿";
  }
  // @ts-ignore
  if (/\./.test(num)) {
    return num;
  }
  return intNum;
}

// 格式化时长
export function formatDuration(seconds: number): string {
  if (isNaN(seconds) || seconds < 0) {
    return "-:-";
  }
  const hour = 60 * 60;
  const minute = 60;

  const hours = Math.floor(seconds / hour);
  let rest = seconds % hour;

  const minutes = Math.floor(rest / minute);
  rest = rest % minute;

  let result = "";
  if (hours >= 1) {
    result = result + formatDigit(hours) + ":";
  }
  result = result + formatDigit(minutes) + ":";
  result = result + formatDigit(rest);

  return result;
}

/**
 * 格式化时间参数为日期对象
 * @param {Date|number|string} time
 * @returns {Date}
 *
 * formatToDate(new Date);      // => Date
 * formatToDate('2021-10');     // => Date
 * formatToDate(1636222480480); // => Date
 */
export function formatToDate(time) {
  const date = time instanceof Date ? time : new Date(time);
  const dateTime = date.getTime();
  if (!dateTime && dateTime !== 0) return null;
  return date;
}

/**
 * 格式化时间为给定格式
 * @param {string} fmtStr 格式化字符串
 * 如：'YYYY-MM-DD hh:mm:ss'
 * 'YYYY-MM-DD hh:mm:ss'
 * 'YYYY年MM月DD日 hh时mm分'
 * 'hh:mm YYYY/MM/DD'
 * @param {Date | number | string} time 时间
 * @returns {string}
 *
 * formatDate('YYYY-MM-DD hh:mm:ss', Date.now());
 */
 export function formatDate(fmtStr, time): string {
  const date = formatToDate(time);
  if (!date) return "";
  const timeObj = {
    "Y+": date.getFullYear(),
    "M+": date.getMonth() + 1,
    "D+": date.getDate(),
    "h+": date.getHours(),
    "m+": date.getMinutes(),
    "s+": date.getSeconds(),
    "S": date.getMilliseconds(),
    "Q": Math.floor((date.getMonth() + 3) / 3)
  };
  let formated = fmtStr;
  Object.keys(timeObj).forEach((k: string) => {
    if (new RegExp(`(${k})`).test(formated)) {
      if (k === "Y+") {
        formated = formated.replace(RegExp.$1, String(timeObj["Y+"]).substr(4 - RegExp.$1.length));
      } else {
        const tmk = timeObj[k];
        const fmt = RegExp.$1.length === 1 ? tmk : `00${tmk}`.substr(String(tmk).length);
        formated = formated.replace(RegExp.$1, fmt);
      }
    }
  });
  return formated;
}